import {WinPresentationController} from "../WinPresentationController";
import {TimelineLite} from "gsap";
import {WalkOfShame} from "../../WalkOfShame";
import {WalkOfShameGameMode} from "../../server/WalkOfShameGameMode";
import {WalkOfShameParsedGameData} from "../../server/data/WalkOfShameParsedGameData";

export class FreespinEndController extends WinPresentationController {

    constructor() {
        super("FreespinEndController", false);
    }

    protected hasWin(): boolean {
        const data: WalkOfShameParsedGameData = WalkOfShame.model.parsedGameData;
        return data.mode !== WalkOfShameGameMode.NORMAL && data.mode !== WalkOfShameGameMode.RESPIN && data.nextMode === WalkOfShameGameMode.NORMAL && !data.brokeTheBank;
    }

    protected async createWinAnimation(): Promise<any> {
        const tl: TimelineLite = new TimelineLite();

        tl.to(this, {duration: 1});
        await tl;
        await new Promise<void>(resolve => {
            WalkOfShame.keypadPlugin.setZeroBetSpinCounter(-1);
            WalkOfShame.freespinOutro.show(() => {
                resolve();
            });
        });
    }
}